<template>
  <div
          class="radar-el"
          :style="{height:height + 'px'}"
  />
<!--    width: (chartWidth * 0.8)+ 'px'-->
</template>

<script>
import echarts from 'echarts'
import { mapGetters } from 'vuex'
require('echarts/theme/macarons') // echarts theme
const animationDuration = 1000
export default {
  props: {
    height: {
      type: Number,
      default: 300,
    },
    chartList:{
      type: Array,
    },
    chartWidth:{
      type: Number,
      default: 300,
    }
  },
  data() {
    return {
      chart: null,
      i:-1,
    }
  },
  mounted() {
    // this.initChart();
    window.addEventListener('resize',this.resetChart);
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose();
    this.chart = null;
    window.removeEventListener("resize",this.resetChart,false);
  },
  watch:{
    chartList(newVal,oldVal){
      if(newVal){
        this.i = -1;
        this.setOption();
      }
    },
    chartWidth(val) {
      if (val) {
        this.initChart();
      }
    },
  },
  computed:{
    ...mapGetters(['realMobile']),
    themeFontColor(){
      return '#333333'
    },
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons');
      this.setOption();
    },
    resetChart(){
      this.chart && this.chart.resize();
    },
    setOption(){
      let _this = this;
      this.chart.setOption({
        tooltip: {
          show: false
        },
        legend: {
          show: false,
          data: [_this.$t('Account_ratings_in_the_past_13_weeks')]
        },
        title: {
          // text: this.centerTitle,
          x: 'center',
          y: 'center',
          textStyle: {
            color: '#ffffff',
            fontWeight: 'bolder',
            fontSize: 64,
          }
        },
        grid: { // 控制图的大小，调整下面这些值就可以，
          x: this.chartWidth,
        },
        textStyle: {
          // color: ["#CCCCCC"],
          // fontSize: 10,
          // margin: [
          //   0,  // 上
          //   10, // 右
          //   5,  // 下
          //   0, // 左
          // ]
        },
        radar: {
          shape: 'circle',
          // axisLine: {
          //   show: false,
          // },
          // ayisLine: {
          //   show: false,
          // },
          splitNumber: 4,
          splitLine: {
            width: 0.5,
            color: '#e2e2e2'
          },
          splitArea:{
            show: false,
          },
          name: {
            textStyle: {
              color: this.themeFontColor,
              borderRadius: 3,
              padding: [3, 5]
            },
            formatter: (a,b)=>{
              this.i++;
              return a + this.chartList[this.i];
            }
          },
          indicator: [
            { name: this.$t('Profitability'),max: 5},
            { name: this.$t('Robustness'),max: 5},
            { name: this.$t('Risk_control_ability'),max: 5},
            { name: this.$t('Fund_size'),max: 5},
            { name: this.$t('Trading_activity'),max: 5},
          ],
          radius: 60,
          center: ['50%','50%'],
        },
        series: [{
          name: '近13周账号评级',
          type: 'radar',
          areaStyle: {
            borderWidth: 0,
            color: '#ff8c58',
            opacity: 0.9
          },
          data: [
            {
              label: { // 单个拐点文本的样式设置
                normal: {
                  show: false,
                  // // 单个拐点文本的样式设置。[ default: false ]
                  // position: 'top',
                  // // 标签的位置。[ default: top ]
                  distance: 5,
                  // // 距离图形元素的距离。当 position 为字符描述值（如 'top'、'insideRight'）时候有效。[ default: 5 ]
                  // color: 'rgba(255,0,0,1)',
                  backgroundColor: '#ffffff',
                  // 文字的颜色。如果设置为 'auto'，则为视觉映射得到的颜色，如系列色。[ default: "#fff" ]
                  fontSize: 14,
                  // 文字的字体大小
                }
              },
              // symbol: "circle",
              lineStyle:{
                color: '#ff8c58'
              },
              value: this.chartList,
              name: '近13周账号评级'
            }
          ]
        }]
      })
    }
  }
}
</script>
<style lang="scss" scoped>
    .radar-el {
        margin: 0 auto;
    }
</style>
